import { createNotification } from '@profgeosoft-ui/react';

import type { TOptions } from 'i18next';

import i18n from './localization-service.ts/i18';

export interface INotificationsService {
  showErrorMessage(text: string): void;
  showErrorMessageT(text: string, options?: TOptions): void;
  showWarningMessage(text: string): void;
  showWarningMessageT(text: string, options?: TOptions): void;
  showSuccessMessage(text: string): void;
  showSuccessMessageT(text: string, options?: TOptions): void;
}

export class NotificationsService {
  showErrorMessage(text: string): void {
    createNotification({
      type: 'error',
      text,
      position: 'bottom-right',
    });
  }

  showErrorMessageT(text: string, options?: TOptions): void {
    const messageText = i18n.t(text, options);

    this.showErrorMessage(messageText);
  }

  showWarningMessage(text: string): void {
    createNotification({
      type: 'info',
      text,
      position: 'bottom-right',
    });
  }

  showWarningMessageT(text: string, options?: TOptions): void {
    const messageText = i18n.t(text, options);

    this.showWarningMessage(messageText);
  }

  showSuccessMessage(text: string): void {
    createNotification({
      type: 'success',
      text,
      position: 'bottom-right',
    });
  }

  showSuccessMessageT(text: string, options?: TOptions): void {
    const messageText = i18n.t(text, options);

    this.showSuccessMessage(messageText);
  }
}
